module.exports = __webpack_public_path__ + "img/3-1.2ceac456.png";